/* eslint-disable @typescript-eslint/quotes */
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import {
  EditModeSelectionState,
  MaterialAnnotationType,
  MaterialDropdownState,
} from '../../material-annotation-list.model';

@Component({
  selector: 'rdrx-material-annotation-list-dropdown',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatMenuModule,
    MatCheckboxModule,
  ],
  templateUrl: './material-annotation-list-dropdown.component.html',
  styleUrls: ['./material-annotation-list-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialAnnotationListDropdownComponent {
  @Input({ required: true }) type!: MaterialAnnotationType;
  @Input({ required: true }) isEditMode: boolean = false;
  @Input({ required: true }) editModeSelections!: EditModeSelectionState;
  @Output() annotationsDropdownState = new EventEmitter<MaterialDropdownState>();
  @Output() allAnnotationsSelected = new EventEmitter();

  MaterialAnnotationType = MaterialAnnotationType;
  MaterialDropdownState = MaterialDropdownState;
  dropdownState: MaterialDropdownState = MaterialDropdownState.ALL;

  getTitleTranslation(type: MaterialAnnotationType): string {
    // eslint-disable-next-line max-len
    return `contents.dropdown_${
      this.dropdownState === MaterialDropdownState.ALL ? 'all' : 'detached'
    }_${type}`;
  }

  handleAllAnnotationsSelected(): void {
    this.dropdownState = MaterialDropdownState.ALL;
    this.annotationsDropdownState.emit(MaterialDropdownState.ALL);
  }

  handleDetachedAnnotationsSelected(): void {
    this.dropdownState = MaterialDropdownState.DETACHED;
    this.annotationsDropdownState.emit(MaterialDropdownState.DETACHED);
  }
}
